/**
 * 확인 필요 (GET /api/shelter/todo) — 헤더 ⚠ 뱃지·홈 카드·동물 목록/상세 칩이 같이 쓰는 상태.
 * 같은 보호소는 30초 안에 다시 부르지 않음(force 면 바로).
 */
import { reactive } from 'vue';

export const TODO_TYPES = [
    { key: 'vaccine', label: '접종 예정·지남', icon: 'bi-capsule', desc: '예정일 7일 이내이거나 지났는데 다음 접종 기록이 없는 보호 중 동물' },
    { key: 'kit', label: '키트 재검사', icon: 'bi-eyedropper', desc: '재검사 예정일이 3일 이내이거나 지났는데 같은 키트로 다시 검사한 기록이 없는 보호 중 동물' },
    { key: 'ended_open', label: '종료 동물 대기 신청서', icon: 'bi-file-earmark-x', desc: '공고가 종료됐는데 대기중 신청서가 남아 있는 동물 (최근 3개월 신청)' },
];

//확인 필요 창·헤더·홈에 보이는 종류 (입양신청서 2종은 동물관리 목록 행 안내·입양관리 띠에서)
export const TODO_MODAL_TYPES = TODO_TYPES.filter(t => t.key == 'vaccine' || t.key == 'kit');

export const todoState = reactive({
    shelter: null,      //불러온 보호소 계정
    loading: false,
    total: 0,
    counts: {},
    items: {},
    byNotify: {},       //공고번호 → { vaccine: 항목, kit: 항목(재검사), adopt: 항목(불일치·종료 대기) }
});

let lastLoaded = 0;
let pending = null;

function rebuild() {
    const by = {};
    const get = (n) => (by[n] = by[n] || { vaccine: null, kit: null, adopt: null });
    ['vaccine', 'kit'].forEach(t => (todoState.items[t] || []).forEach(i => {
        const e = get(i.notify_number);
        if (!e[t] || i.days < e[t].days) e[t] = i;   //가장 급한 것
    }));
    (todoState.items.ended_open || []).forEach(i => { get(i.notify_number).adopt = i; });
    todoState.byNotify = by;
    let total = 0;
    const counts = {};
    TODO_TYPES.forEach(t => { counts[t.key] = (todoState.items[t.key] || []).length; total += counts[t.key]; });
    todoState.counts = counts;
    todoState.total = total;
}

export function loadTodo(axios, shelter, force) {
    if (!shelter) return Promise.resolve();
    const now = Date.now();
    if (!force && todoState.shelter === shelter && now - lastLoaded < 30000) return Promise.resolve();
    if (pending && !force) return pending;
    todoState.loading = true;
    pending = axios.get(`/shelter/todo?shelter_device_number=${encodeURIComponent(shelter)}`)
        .then(res => {
            const d = res.data || {};
            todoState.shelter = shelter;
            todoState.items = d.items || {};
            rebuild();
            lastLoaded = Date.now();
        })
        .catch(e => { console.log('확인 필요 조회 실패', e); })
        .finally(() => { todoState.loading = false; pending = null; });
    return pending;
}
